// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rAOxsH8yB5YT9Kmh .ant-modal-content {
  padding: 0;
  border-radius: 12px;
  overflow: hidden;
}
.rAOxsH8yB5YT9Kmh .ant-modal-header {
  margin: 0;
  padding: 16px 24px;
  border-bottom: 1px solid #f3f4f6;
}
.rAOxsH8yB5YT9Kmh .ant-modal-title {
  font-size: 15px !important;
  font-weight: 700;
  color: #1f2937;
}
.rAOxsH8yB5YT9Kmh .ant-modal-body {
  padding: 16px 32px;
  max-height: 72vh;
  overflow-y: auto;
}
.rAOxsH8yB5YT9Kmh .ant-modal-footer {
  margin: 0;
  padding: 20px 24px;
  text-align: center;
  border-top: 1px solid #f3f4f6;
}
.rAOxsH8yB5YT9Kmh .ant-modal-footer .ant-btn-default {
  min-width: 72px;
  height: 36px;
  font-size: 13px;
  border-color: #e5e7eb;
  color: #4b5563;
}
.rAOxsH8yB5YT9Kmh .ant-modal-footer .ant-btn-primary {
  min-width: 88px;
  height: 36px;
  font-size: 13px;
  background: #1677ff;
  border-color: #1677ff;
}
.rAOxsH8yB5YT9Kmh .ant-form-item {
  margin-bottom: 0;
}
.rAOxsH8yB5YT9Kmh .ant-form-item-explain-error {
  font-size: 12px;
  margin-top: 4px;
}
.iyYo8ZXjCUou135U {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.si1nTG3BW50t5eCQ {
  display: flex;
  align-items: center;
}
.BFr7CqjqwwLgLspq {
  display: flex;
  align-items: flex-start;
}
.nmZRx5MIXKAp0TvB {
  width: 112px;
  padding-right: 12px;
  flex-shrink: 0;
  text-align: right;
  font-size: 13px;
  color: #374151;
  line-height: 36px;
}
.dHuNmOC3wFoht57g {
  width: 112px;
  padding-right: 12px;
  flex-shrink: 0;
  text-align: right;
  font-size: 13px;
  color: #374151;
  line-height: 20px;
  margin-top: 8px;
}
.tII7MM0WI2cKTLvO {
  margin-right: 4px;
  color: #ef4444;
}
.NnwbnD8LHgkzToHi {
  flex: 1;
  min-width: 0;
}
.Rdp7W53swZp718r3 {
  width: 128px;
  flex-shrink: 0;
}
.s90tupZEMLxycPk9 {
  width: 100%;
  height: 36px;
  padding: 0 12px;
  font-size: 13px;
  color: #111827;
  background: #eef1f6;
  border: 1px solid transparent;
  border-radius: 6px;
}
.s90tupZEMLxycPk9::placeholder {
  color: #9ca3af;
}
.s90tupZEMLxycPk9:hover,
.s90tupZEMLxycPk9:focus {
  background: #fff;
  border-color: #1677ff;
  box-shadow: none;
}
.XHdH3jcEAcQBiOnP {
  width: 128px;
}
.XHdH3jcEAcQBiOnP .ant-select-selector {
  height: 36px !important;
  background: #eef1f6 !important;
  border: 1px solid transparent !important;
  border-radius: 6px !important;
  font-size: 13px !important;
}
.XHdH3jcEAcQBiOnP .ant-select-selection-item {
  line-height: 34px !important;
}
.CHnd4hYkmYgh8zXk {
  width: 100%;
}
.CHnd4hYkmYgh8zXk .ant-select-selector {
  height: 36px !important;
  background: #fff !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 6px !important;
  font-size: 13px !important;
}
.CHnd4hYkmYgh8zXk .ant-select-selection-placeholder {
  color: #9ca3af !important;
}
.CHnd4hYkmYgh8zXk .ant-select-selection-item {
  line-height: 34px !important;
}
.j3bblVs6RD8xtnPC {
  width: 100%;
  min-height: 96px;
  padding: 8px 12px;
  font-size: 13px;
  color: #111827;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  resize: none;
}
.j3bblVs6RD8xtnPC:hover,
.j3bblVs6RD8xtnPC:focus {
  border-color: #1677ff;
  box-shadow: none;
}
.LfOmY2UXOXUfolbO {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 4px 0;
}
.FB7N7KBllRsuQCR2 {
  flex: 1;
  height: 1px;
  background: #f3f4f6;
}
.JzpQm1TmerQYsBJe {
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 500;
  color: #111827;
}
`, "",{"version":3,"sources":["webpack://./app/assets/pages/intl/components/AddModal/index.modules.less"],"names":[],"mappings":"AAAA;EAGM,UAAA;EACA,mBAAA;EACA,gBAAA;AADN;AAJA;EASM,SAAA;EACA,kBAAA;EACA,gCAAA;AAFN;AATA;EAeM,0BAAA;EACA,gBAAA;EACA,cAAA;AAHN;AAdA;EAqBM,kBAAA;EACA,gBAAA;EACA,gBAAA;AAJN;AAnBA;EA2BM,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;AALN;AAzBA;EAkCM,eAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;AANN;AAhCA;EA0CM,eAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;AAPN;AAvCA;EAkDM,gBAAA;AARN;AA1CA;EAsDM,eAAA;EACA,eAAA;AATN;AAcA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAZF;AAeA;EACE,aAAA;EACA,mBAAA;AAbF;AAgBA;EACE,aAAA;EACA,uBAAA;AAdF;AAiBA;EACE,YAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AAfF;AAkBA;EACE,YAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AAhBF;AAmBA;EACE,iBAAA;EACA,cAAA;AAjBF;AAoBA;EACE,OAAA;EACA,YAAA;AAlBF;AAqBA;EACE,YAAA;EACA,cAAA;AAnBF;AAsBA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;AApBF;AAsBE;EACE,cAAA;AApBJ;AAuBE;;EAEE,gBAAA;EACA,qBAAA;EACA,gBAAA;AArBJ;AAyBA;EACE,YAAA;AAvBF;AAsBA;EAII,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,6BAAA;EACA,0BAAA;AAvBJ;AAeA;EAYI,4BAAA;AAxBJ;AA4BA;EACE,WAAA;AA1BF;AAyBA;EAII,uBAAA;EACA,2BAAA;EACA,oCAAA;EACA,6BAAA;EACA,0BAAA;AA1BJ;AAkBA;EAYI,yBAAA;AA3BJ;AAeA;EAgBI,4BAAA;AA5BJ;AAgCA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AA9BF;AAgCE;;EAEE,qBAAA;EACA,gBAAA;AA9BJ;AAkCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AAhCF;AAmCA;EACE,OAAA;EACA,WAAA;EACA,mBAAA;AAjCF;AAoCA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAlCF","sourcesContent":[".intlAddModal {\n  :global {\n    .ant-modal-content {\n      padding: 0;\n      border-radius: 12px;\n      overflow: hidden;\n    }\n\n    .ant-modal-header {\n      margin: 0;\n      padding: 16px 24px;\n      border-bottom: 1px solid #f3f4f6;\n    }\n\n    .ant-modal-title {\n      font-size: 15px !important;\n      font-weight: 700;\n      color: #1f2937;\n    }\n\n    .ant-modal-body {\n      padding: 16px 32px;\n      max-height: 72vh;\n      overflow-y: auto;\n    }\n\n    .ant-modal-footer {\n      margin: 0;\n      padding: 20px 24px;\n      text-align: center;\n      border-top: 1px solid #f3f4f6;\n    }\n\n    .ant-modal-footer .ant-btn-default {\n      min-width: 72px;\n      height: 36px;\n      font-size: 13px;\n      border-color: #e5e7eb;\n      color: #4b5563;\n    }\n\n    .ant-modal-footer .ant-btn-primary {\n      min-width: 88px;\n      height: 36px;\n      font-size: 13px;\n      background: #1677ff;\n      border-color: #1677ff;\n    }\n\n    .ant-form-item {\n      margin-bottom: 0;\n    }\n\n    .ant-form-item-explain-error {\n      font-size: 12px;\n      margin-top: 4px;\n    }\n  }\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.row {\n  display: flex;\n  align-items: center;\n}\n\n.rowTop {\n  display: flex;\n  align-items: flex-start;\n}\n\n.label {\n  width: 112px;\n  padding-right: 12px;\n  flex-shrink: 0;\n  text-align: right;\n  font-size: 13px;\n  color: #374151;\n  line-height: 36px;\n}\n\n.labelTop {\n  width: 112px;\n  padding-right: 12px;\n  flex-shrink: 0;\n  text-align: right;\n  font-size: 13px;\n  color: #374151;\n  line-height: 20px;\n  margin-top: 8px;\n}\n\n.required {\n  margin-right: 4px;\n  color: #ef4444;\n}\n\n.control {\n  flex: 1;\n  min-width: 0;\n}\n\n.controlFixed {\n  width: 128px;\n  flex-shrink: 0;\n}\n\n.input {\n  width: 100%;\n  height: 36px;\n  padding: 0 12px;\n  font-size: 13px;\n  color: #111827;\n  background: #eef1f6;\n  border: 1px solid transparent;\n  border-radius: 6px;\n\n  &::placeholder {\n    color: #9ca3af;\n  }\n\n  &:hover,\n  &:focus {\n    background: #fff;\n    border-color: #1677ff;\n    box-shadow: none;\n  }\n}\n\n.selectEnv {\n  width: 128px;\n\n  :global(.ant-select-selector) {\n    height: 36px !important;\n    background: #eef1f6 !important;\n    border: 1px solid transparent !important;\n    border-radius: 6px !important;\n    font-size: 13px !important;\n  }\n\n  :global(.ant-select-selection-item) {\n    line-height: 34px !important;\n  }\n}\n\n.selectType {\n  width: 100%;\n\n  :global(.ant-select-selector) {\n    height: 36px !important;\n    background: #fff !important;\n    border: 1px solid #e5e7eb !important;\n    border-radius: 6px !important;\n    font-size: 13px !important;\n  }\n\n  :global(.ant-select-selection-placeholder) {\n    color: #9ca3af !important;\n  }\n\n  :global(.ant-select-selection-item) {\n    line-height: 34px !important;\n  }\n}\n\n.textarea {\n  width: 100%;\n  min-height: 96px;\n  padding: 8px 12px;\n  font-size: 13px;\n  color: #111827;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  resize: none;\n\n  &:hover,\n  &:focus {\n    border-color: #1677ff;\n    box-shadow: none;\n  }\n}\n\n.divider {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 4px 0;\n}\n\n.dividerLine {\n  flex: 1;\n  height: 1px;\n  background: #f3f4f6;\n}\n\n.dividerText {\n  flex-shrink: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #111827;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"intlAddModal": `rAOxsH8yB5YT9Kmh`,
	"form": `iyYo8ZXjCUou135U`,
	"row": `si1nTG3BW50t5eCQ`,
	"rowTop": `BFr7CqjqwwLgLspq`,
	"label": `nmZRx5MIXKAp0TvB`,
	"labelTop": `dHuNmOC3wFoht57g`,
	"required": `tII7MM0WI2cKTLvO`,
	"control": `NnwbnD8LHgkzToHi`,
	"controlFixed": `Rdp7W53swZp718r3`,
	"input": `s90tupZEMLxycPk9`,
	"selectEnv": `XHdH3jcEAcQBiOnP`,
	"selectType": `CHnd4hYkmYgh8zXk`,
	"textarea": `j3bblVs6RD8xtnPC`,
	"divider": `LfOmY2UXOXUfolbO`,
	"dividerLine": `FB7N7KBllRsuQCR2`,
	"dividerText": `JzpQm1TmerQYsBJe`
};
export default ___CSS_LOADER_EXPORT___;
